import React, { FunctionComponent, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import Header from 'components/header/Header.container';
import DashboardLink from 'components/DashboardLink/DashboardLink';
import HelpLeftNavBar from 'components/helpLeftNavBar/HelpLeftNavBar';
import BrowserSettings from './browserSettings/BrowserSettings';
import OSPrivacySettings from './osPrivacySettings/OSPrivacySettings';
import NotificationSettings from './notificationSettings/NotificationSettings';
import Styles from './Help.module.scss';

const Help: FunctionComponent = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div>
      <Header />
      <div className="custom-container">
        <DashboardLink iconClass="fas fa-chevron-left" cssClass={Styles.dashboardLink} />
        <div className={`${Styles.helpWrapper} ${menuOpen ? Styles.menuOpen : ''}`}>
          {menuOpen && <div className={Styles.menuOverlay} onClick={closeMenu} />}
          <button className={Styles.mobileMenuButton} onClick={toggleMenu} aria-label="Toggle menu">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
          <div className={Styles.leftSide}>
            <HelpLeftNavBar onLinkClick={closeMenu} />
          </div>
          <div className={Styles.rightSide}>
            <Switch>
              <Route exact path="/help/browser-settings">
                <BrowserSettings />
              </Route>
              <Route exact path="/help/os-privacy-settings">
                <OSPrivacySettings />
              </Route>
              <Route exact path="/help/notification-settings">
                <NotificationSettings />
              </Route>
              <Route exact path="/help">
                <BrowserSettings />
              </Route>
            </Switch>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Help;